import React from 'react';
import { BsCheck2Circle, BsExclamationCircle, BsInfoCircle, BsX } from 'react-icons/bs';
import { Flex, Icon, IconButton, Text, useStyleConfig } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../constants/cypressIds';

const Toast = ({
  size,
  title,
  status,
  isClosable,
  description,
  ...rest
}) => {
  const variant = status || 'general';
  const styles = useStyleConfig('Toast', { size, variant });

  const iconMap = {
    info: BsInfoCircle,
    success: BsCheck2Circle,
    warning: BsExclamationCircle
  };

  return (
    <Flex alignItems="center" id={rest.id} sx={styles}>
      <Flex alignItems="center" height="100%" justify="center" position="relative" width="100%">

        {iconMap[status] && (
          <Icon
            as={iconMap[status]}
            boxSize="20px"
            left="15px"
            position="absolute"
          />
        )}

        <Flex
          alignItems="center"
          data-cy={`toast-${status}`}
          direction="column"
          dusk={`toast-${status}`}
          height="100%"
          justify="space-around"
          margin="0 auto"
          py={1}
          width="75%"
        >
          <Flex alignItems="center" height="100%">{title}</Flex>
          {description && (
          <Text overflowWrap="break-word" textStyle="bodyMd">
            {description}
          </Text>
          )}
        </Flex>

        {isClosable && (
          <IconButton
            aria-label="close"
            data-cy={CypressIds.closeToastButton(status)}
            icon={<Icon as={BsX} boxSize="18px" />}
            position="absolute"
            right="15px"
            size="xs"
            variant="textWhite"
            onClick={rest.onClose}
          />
        )}
      </Flex>
    </Flex>
  );
};

Toast.propTypes = {
  /** Height of toast. `md='40px'`, `lg='48px'` */
  size: PropTypes.oneOf(['md', 'lg']),
  /** Main text to be displayed on toast */
  title: PropTypes.string.isRequired,
  /** Sub-text or message for toast */
  description: PropTypes.string,
  /** Determines the style of the toast */
  status: PropTypes.oneOf(['info', 'general', 'error', 'success', 'warning']),
  /** If `true` the toast will have a close button */
  isClosable: PropTypes.bool
};

Toast.defaultProps = {
  size: 'lg',
  status: 'general',
  isClosable: true
};

export default Toast;
